import section from "fragments/section"
import gql from "graphql-tag"

const category = gql`
  ${section}

  fragment Category on Category {
    commentCount
    createdAt
    description
    id
    name
    order
    section {
      ...Section
    }
    slug
    topicCount
    updatedAt
  }
`

export default category
